import ImagesPopup from './ImagesPopup';

export default ImagesPopup;
